import React, { useState, useEffect } from "react";

export default function RatingStars({
  ratingValue = 0,
  isReadOnly = false,
  onChange,
  label = "Recipe Rating",
  size = 25, // default size to match WPRM visuals
}) {
  const [hoverRating, setHoverRating] = useState(0);
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const displayRating = hoverRating || ratingValue;

  useEffect(() => {
    const detectTheme = () => {
      const theme = document.documentElement.getAttribute("data-bs-theme");
      setIsDarkTheme(
        theme === "dark" ||
          (!theme && window.matchMedia("(prefers-color-scheme: dark)").matches)
      );
    };

    detectTheme();

    const observer = new MutationObserver(detectTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-bs-theme"],
    });

    return () => observer.disconnect();
  }, []);

  const fillColor = isDarkTheme ? "#FFD700" : "#343434";
  const strokeColor = isDarkTheme ? "#FFD700" : "#343434";

  const StarSVG = ({ filled, index }) => (
    <svg
      key={index}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{
        cursor: isReadOnly ? "default" : "pointer",
        margin: "0 4px",
        transition: "transform 0.15s ease, filter 0.15s ease",
        transform: filled ? "scale(1.08)" : "scale(1)",
        display: "inline-block",
      }}
      onMouseEnter={() => !isReadOnly && setHoverRating(index + 1)}
      onMouseLeave={() => !isReadOnly && setHoverRating(0)}
      onClick={() => !isReadOnly && onChange && onChange(index + 1)}
      aria-hidden={isReadOnly}
      role={isReadOnly ? "img" : "button"}
      tabIndex={isReadOnly ? -1 : 0}
      onKeyDown={(e) => {
        if (!isReadOnly && (e.key === "Enter" || e.key === " ")) {
          onChange && onChange(index + 1);
        }
      }}
    >
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        fill={filled ? fillColor : "none"}
        stroke={strokeColor}
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div
      className="wprm-rating-display"
      style={{ width: "100%", boxSizing: "border-box" }}
    >
      {label && (
        <label
          style={{
            display: "block",
            marginBottom: "0.25rem",
            fontWeight: 500,
            color: isDarkTheme ? "#f0f0f0" : "#333",
            textAlign: "center",
          }}
        >
          {label}
        </label>
      )}

      {/* Centering container */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <StarSVG key={i} index={i} filled={displayRating > i} />
        ))}

        {/* inline numeric label for interactive UI (hidden for read-only) */}
        {!isReadOnly && ratingValue > 0 && (
          <span
            style={{
              marginLeft: "0.5rem",
              fontSize: "0.9rem",
              color: isDarkTheme ? "#FFD700" : "#666",
              fontWeight: 500,
            }}
          >
            {ratingValue}/5
          </span>
        )}
      </div>
    </div>
  );
}